// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1O4Ql","tab":"Tabs_tab__3CEZP","tabActive":"Tabs_tabActive__1RP5B"};